// extracted by mini-css-extract-plugin
export default {"container":"manage-link_container__JmLjm","section":"manage-link_section__07XPv"};